import { Modal, Button } from 'react-bootstrap';
import Humanize from 'humanize-plus';

export const UploadFileModal = ({ show, handleCancel, handleSave, setFiles, optionalFilePath, setOptionalFilePath, uploadProgress, totalSize }) => {

    return show ?
        (
            <Modal
                show={show}
                onHide={handleCancel}
                backdrop="static"
                keyboard={true}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Upload Files</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row mb-5'>
                        <div className='col-md-12'>
                            <input className='w-100' type="file" onChange={e => setFiles(e.target.files)} multiple />
                        </div>
                    </div>
                    <div className='row mb-5'>
                        <div className='col-md-12'>
                            <input className='w-100' type="text" value={optionalFilePath} placeholder='Add optional folder (eg folder1/folder2)' onChange={e => setOptionalFilePath(e.target.value)} />
                        </div>
                    </div>
                    <div className='row '>
                        <div className='col-md-12'>
                            {!!totalSize && totalSize > 0 && <div>{Humanize.fileSize(totalSize)} to upload.</div>}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='row w-100'>
                        <div className='col-xl-7'>
                            {!!uploadProgress && uploadProgress === 0 && <div>Starting upload... please wait</div>}
                            {!!uploadProgress && uploadProgress > 0 && <div className="mt-10px progress-bar bg-indigo progress-bar-striped progress-bar-animated rounded-pill fs-10px fw-bold" style={{ width: uploadProgress * 100 + '%' }}>{`${(uploadProgress * 100).toFixed(2)}%`}</div>}
                        </div>
                        <div className='col-xl-5 text-end'>
                            <Button className='me-5px' variant="secondary" onClick={handleCancel}>
                                Close
                            </Button>
                            <Button variant="primary" onClick={handleSave}>
                                <i className="fa fa-fw fa-arrow-up"></i>
                                Upload
                            </Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        ) :
        (<></>);
};